import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

function UpdateArLevels() {
  const id = window.location.pathname.split("/")[2];
  const [redirect, setRedirect] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: "", color: "success" });
  const [subjects, setSubjects] = useState([]);
  const [topics, setTopics] = useState([]);
  const [form, setForm] = useState({
    subject_id: "",
    topic_id: "",
    level_name: "",
    level_type: "easy",
    status: "active",
  });

  useEffect(() => {
    if (init() !== "success") return;
    axios
      .get(`${Constants.getUrls.getAllSubjects}?search=&limit=1000&page=1`)
      .then((resp) => setSubjects(resp?.data?.data?.docs || []));
  }, []);

  useEffect(() => {
    if (!id || init() !== "success") return;
    axios.get(`${Constants.getUrls.getAllArLevels}/${id}`).then((resp) => {
      const data = resp?.data?.data || {};
      setForm({
        subject_id: data?.subject_id?._id || data?.subject_id || "",
        topic_id: data?.topic_id?._id || data?.topic_id || "",
        level_name: data?.level_name || "",
        level_type: data?.level_type || "easy",
        status: data?.status || "active",
      });
    });
  }, [id]);

  useEffect(() => {
    if (!form.subject_id || init() !== "success") {
      setTopics([]);
      return;
    }
    axios
      .get(`${Constants.getUrls.getAllTopics}?subject_id=${form.subject_id}`)
      .then((resp) => setTopics(resp?.data?.data?.docs || []));
  }, [form.subject_id]);

  const showMessage = (message, color = "success", next = false) => {
    setNotification({ open: true, message, color });
    setTimeout(() => {
      setNotification({ open: false, message: "", color: "success" });
      if (next) setRedirect(true);
    }, 2500);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await axios.put(`${Constants.putUrls.updateArLevel}${id}`, form);
      showMessage("AR level updated successfully!", "success", true);
    } catch (error) {
      showMessage(error?.response?.data?.message || "Unable to update AR level.", "error");
    }
  };

  if (redirect) {
    return <Navigate to="/ar-levels" />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Update AR Level
            </MDTypography>
          </MDBox>
          <MDBox py={3} px={2}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <InputLabel>Select Subject</InputLabel>
                  <Select
                    value={form.subject_id}
                    onChange={(e) => setForm((prev) => ({ ...prev, subject_id: e.target.value, topic_id: "" }))}
                    required
                    style={{ width: "100%", height: "45px", color: "#111" }}
                  >
                    <MenuItem value="">Select Subject</MenuItem>
                    {subjects.map((item) => (
                      <MenuItem value={item._id} key={item._id} style={{ color: "#111" }}>
                        {item.subject_name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel>Select Topic</InputLabel>
                  <Select
                    value={form.topic_id}
                    onChange={(e) => setForm((prev) => ({ ...prev, topic_id: e.target.value }))}
                    required
                    style={{ width: "100%", height: "45px", color: "#111" }}
                  >
                    <MenuItem value="">Select Topic</MenuItem>
                    {topics.map((item) => (
                      <MenuItem value={item._id} key={item._id} style={{ color: "#111" }}>
                        {item.topic_name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel>Level Name</InputLabel>
                  <TextField
                    value={form.level_name}
                    onChange={(e) => setForm((prev) => ({ ...prev, level_name: e.target.value }))}
                    style={{ width: "100%" }}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputLabel>Select Level Type</InputLabel>
                  <Select
                    value={form.level_type}
                    onChange={(e) => setForm((prev) => ({ ...prev, level_type: e.target.value }))}
                    required
                    style={{ width: "100%", height: "45px", color: "#111" }}
                  >
                    <MenuItem value="easy">Easy</MenuItem>
                    <MenuItem value="medium">Medium</MenuItem>
                    <MenuItem value="hard">Hard</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12} md={3}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={form.status}
                    onChange={(e) => setForm((prev) => ({ ...prev, status: e.target.value }))}
                    required
                    style={{ width: "100%", height: "45px", color: "#111" }}
                  >
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid align="left" mt={2}>
                <MDButton variant="contained" size="small" color="info" type="submit">
                  Update
                </MDButton>
              </Grid>
            </form>
          </MDBox>
          <MDSnackbar
            color={notification.color}
            icon="notifications"
            title="AgriQuiz AR Levels"
            content={notification.message}
            dateTime="Just now"
            open={notification.open}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default UpdateArLevels;
